// extracted by mini-css-extract-plugin
export var cardTitle = "_ir-1";
export var commentBubble = "_ir-e";
export var commentForm = "_ir-a";
export var commentInput = "_ir-b";
export var commentLabel = "_ir-d";
export var commentPrompt = "_ir-9";
export var csatCard = "_ir-0";
export var feedbackSection = "_ir-7";
export var starDisabled = "_ir-6";
export var starEmpty = "_ir-5";
export var starFilled = "_ir-4";
export var starWrapper = "_ir-3";
export var starsContainer = "_ir-2";
export var submittedComment = "_ir-c";
export var thankYouText = "_ir-8";